const setFrameSource = (frame, url, params = {}) => {
  const src = new URL(url, window.location.origin);
  src.searchParams.set('frame_id', frame.id);
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      src.searchParams.set(key, value);
    }
  }
  frame.src = src.toString();
};

export default setFrameSource;
